import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Box, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import appFetch from '../../../../api/appFetch.js';
import { BookingDateMarkersUrl } from '../../../../constants/apiUrls.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';

export default class BookingDateMarkersCreation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            outletId: this.props.outletId !== undefined ? parseInt(this.props.outletId) : 0,
            year: parseInt(this.props.year),
            description: "",
            isOutletClosed: false,
            dateFrom: "",
            dateTill: "",
            loading: false,
            redirect: false,
            requestInProgress: false,
            open: true,
            bookingDateMarkersWasCreated: false,
        };
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/bookingdatemarkers" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleValidFrom = value => {
        this.setState({ dateFrom: value });
    };

    handleValidTill = value => {
        this.setState({ dateTill: value });
    };

    isValidForm = () => {
        const { dateFrom, dateTill } = this.state;

        if (!dateFrom) {
            return false;
        }

        if (!dateTill) {
            return false
        }

        const momentDateFrom = moment(dateFrom, "YYYY/MM/DD");
        const momentDateTill = moment(dateTill, "YYYY/MM/DD");

        if (!momentDateFrom.isValid() || !momentDateTill.isValid() || momentDateTill.isBefore(momentDateFrom)) {
            return false;
        }

        return true;
    }

    handleSubmit = () => {
        this.saveNewBookingDateMark();
    }

    saveNewBookingDateMark = () => {

        let resources = this.props.resources;

        if (!this.isValidForm()) {
            return;
        }

        this.setState({ requestInProgress: true });

        const { outletId, description, dateFrom, dateTill, isOutletClosed } = this.state;

        var json = JSON.stringify({
            moboOutletId: outletId === 0 ? null : outletId,
            dateFrom: dateFrom,
            dateTill: dateTill,
            description: description,
            isClosure: isOutletClosed
        });

        const url = BookingDateMarkersUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        updateInProgress: false,
                        bookingDateMarkersWasCreated: true,
                        redirect: "/bookingdatemarkers"
                    });
                    DisplayMessage(resources["BookingDateMarkerWasSaved"], "success");
                }
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderForm() {
        const { dateFrom, dateTill, description, isOutletClosed, outletId } = this.state;
        var resources = this.props.resources;

        const moboOutlet = this.props.accessibleMoboOutlets.find(({ id }) => id === outletId);
        var moboOutletDesc = moboOutlet === undefined ? "-" : moboOutlet.description;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group>
                        <div className="d-flex">
                            <div className="col-3"></div>
                            <h5>{resources["Outlet"]}: {moboOutletDesc}</h5>
                        </div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <Box display="flex" justifyContent="space-between" className='col-6' padding="0" gap="15px">
                            <DatePickerComponent
                                id="dateFrom"
                                label={resources["DateMarkersDateFrom"]}
                                value={dateFrom}
                                onChange={this.handleValidFrom}
                                error={!dateFrom}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                            <DatePickerComponent
                                id="dateTill"
                                name
                                label={resources["DateMarkersDateTill"]}
                                value={dateTill}
                                onChange={this.handleValidTill}
                                error={!dateTill}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                        </Box>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 " id="bookingdatemarkers-description"
                                value={description} label={resources["Description"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "></div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingDateMarkers-isOutletClosed" checked={isOutletClosed} onChange={this.handleChangeCheckBox} name="isOutletClosed" color="primary" />}
                            label={resources["IsOutletClosedThisPeriod"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                </Form>
            </Paper>
        )
    }


    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return (<div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')} style={{ textAlign: "center" }}>
            {this.renderForm()}
        </div>);
    }

    render() {
        const { redirect, open, bookingDateMarkersWasCreated, outletId, requestInProgress, year } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: bookingDateMarkersWasCreated, outletId, year } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-new-bookingdatemarkers" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["NewBookingDateMarkers"]}
                            </Typography>
                            <Button id="bookingdatemarkers-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div>
        );
    }
}